import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';


// customizable method: use your own `Plotly` object
import createPlotlyComponent from 'react-plotly.js/factory';
//const Plot = createPlotlyComponent(Plotly);

import backend_url from "../../../../routes/API_URL";

import swal from 'sweetalert';


const API_URL = backend_url['api_url'];


var Plotly = require('plotly.js')
//var createPlotlyComponent = require('plotlyjs-react')
var Plot = createPlotlyComponent(Plotly)



class ProgressGraph extends Component {
     constructor(props) {
		super(props);
		//const visit_id=this.props.visit_id;
		const year_id = props.year_id;
		
		const date_object1 = new Date();
		const current_year1 = date_object1.getFullYear();
		
		this.state = {
		   Graph_Data:[],
		   year:year_id,
		   current_year1:current_year1,
		   bearer_auth:window.sessionStorage.getItem('token'),
		};
		
		this.abortController = new AbortController();

	  }
	  
	  /* componentDidMount () {
		 
		 Promise.all([axios.get(API_URL + `/progress_report/${this.state.current_year1}`)]).then(
		 //Promise.all([axios.get(API_URL + `/progress_report/`)]).then(
		 ([g_data])=>{
			 this.setState({
				 Graph_Data:g_data.data,
			 })
		 }
		 )
	  } */
	  
	  componentDidMount () {
		 
		 //Promise.all([axios.get(API_URL + `/progress_report/${this.state.current_year1}`)]).then(
		 Promise.all([axios.get(API_URL + `/progress_report`,{ headers: {"Authorization" : `Bearer ${this.state.bearer_auth}`}, signal: this.abortController.signal})]).then(
		 ([g_data])=>{
			 this.setState({
				 Graph_Data:g_data.data,
			 })
		 }
		 ).catch(error => {
			  swal({
				  title: "",
				  text: error.name + " : " + error.message + ". For security reasons we're logging you out.",
				  icon: "error",
				  timer : 1250
				})
				.then((sucess) => {
					// window.sessionStorage.clear();
					// window.location.reload();
				});
          })
	  }
	  
	  componentWillUnmount(){
		this.abortController.abort();
	  }
	  
    render() {
		const {Graph_Data} = this.state;
		
		
		const date_object = new Date();
		const current_year = date_object.getFullYear();
		const years = []
		const average_achievement = []
		const years_dataset = []
		const average_achievement_dataset=[]
		const x_label = [];
		const y_label = []
		const data_container  =[];
		const nes_label = [];
		
		
		for(let i=0; i<Graph_Data.length; i++){
				
				nes_label.push(Graph_Data[i]['NES']);
				years.push(Graph_Data[i]['DATE'])
				//average_achievement.push(Graph_Data[i]['ACHIEVEMENT'])
			} 
		
		
		const unique_years = [...new Set(years)]
		/* const code = {x: [x_label], y:[y_label]}
		
		console.log("Printing code");
		console.log(code); */
		const color_labels = ['#efac51','#84674','#cbec0d','#798a16','#080d4f','#e10e41','#76525b','#4e3239','#2ec487','#13271f','#7f49a9','#4c0f7c','#af8ccb','#300750','#eb26af','#2ecc71','#943126','#f8c471','#7d3c98','#fdedec','#aed6f1'];
		
		
		for(let y=0; y<unique_years.length;y++){
			
			//console.log(current_year-unique_years[y]);
			
			if(parseInt(current_year-unique_years[y])<10 && parseInt(current_year-unique_years[y])>=0){	
				//const m = {type:'bar',mode: 'group', x:[],y:[], marker: {color:[]}, text:[],name:''}
				const m = {type:'bar',mode: 'group', x:[],y:[], text:[],name:''}	
				for(let i=0; i<Graph_Data.length; i++){
				  if(Graph_Data[i]['DATE']== unique_years[y]){
					//m['type'].push('bar');
					m['x'].push(Graph_Data[i]['NES']);
					m['y'].push(Graph_Data[i]['ACHIEVEMENT']);
					m['text'].push(Graph_Data[i]['DATE']);
					m['name'] = Graph_Data[i]['DATE'];
				  }
					
				}
				data_container.push(m);	
            }				
			
		}
		
		
		
		/* console.log('Printing m ');
		console.log(m); */
		//console.log('Printing Data ');
		//console.log(data_container);
		
		const data = [];
		
		for(let d=0; d<data_container.length; d++){
			data.push(data_container[d]);
		}
		
		/* const data = [
		  {
			type: 'bar',
			mode: 'lines+points',
			x: [1,2,3],
			y: [2,4,4],
			marker: {color: 'red'},
			text: ['Apples', 'Pears', 'Peaches'],
		  },
		  {
			type: 'bar',
			x: [1,2,3],
			y: [2,4,4],
			marker: {color: 'blue'},
			text: ['Apples', 'Pears', 'Peaches'],
		  },
		]; */
		
		
		/* let data =[{}]
		
		for(let i=0; i<Graph_Data.length; i++){
				for(let v=0; v<average_achievement.length;v++){
				    if(parseInt(current_year-Graph_Data[i]['DATE']) <=10){
						  data[v]['type'] = 'bar';
						  data[v]['x'] = Graph_Data[i]['NES'];
						  data[v]['y'] = Graph_Data[i]['COUNT'];
						  data[v]['text'] = Graph_Data[i]['DATE'];
					}
				 
				}
				
		}  */
		
		//console.log("Data Values");
		//console.log(data);
		
		const layout= {
			title:"NATIONAL PROGRESS OVERVIEW",
			autosize: true,
			 xaxis: {
				type: 'category',
				title: 'National Education standards',
				"categoryorder": "array",
                "categoryarray":  nes_label
			  },
			  yaxis: {
				title: 'Average NES Level'
			  },
		}
		
		const useResizeHandler= true;
		const style = {width: "100%", height: "100%"}
		
		const opt =  {
		  responsive: true,
		  displaylogo: false
		}
        return (
            <React.Fragment>
                <Plot
					data={data}
					layout={layout}
				    useResizeHandler={useResizeHandler}
					style={style}
				  />
            </React.Fragment>
        );
    }
}

export default ProgressGraph;